/* eslint-disable @typescript-eslint/consistent-indexed-object-style */

import {GHGEmissionConst} from '../generalized/constants/renderConstants';

/* eslint-disable no-console */
export const filterMainAndSubData: (
  data: any[],
  searchDataKey: string,
  keyArray: string[]
) => {
  mainData: {
    [key: string]: any;
  };
  subData: any[];
} = (data: any[], searchDataKey, keyArray) => {
  const mainKey = keyArray?.[0] ?? '';
  const sectionData = data?.filter((item) => {
    return keyArray.includes(item?.dataId);
  });

  return keyArray?.length === 1
    ? {mainData: sectionData?.[0], subData: sectionData?.[0]?.data}
    : {
        mainData: sectionData?.find((item) => {
          return item?.[searchDataKey] === mainKey;
        }),
        subData: sectionData?.filter((item) => {
          return item?.[searchDataKey] !== mainKey;
        })
      };
};

export const checkNA = (value: number | string): number => {
  return typeof value !== 'string' ? value : 0;
};

export const calculatePercentage = (
  value: number | string,
  totalValue: number,
  roundTo: number = 2
): string => {
  const mainValue = checkNA(value) / totalValue;

  return isNaN(mainValue) ? '0' : (mainValue * 100).toFixed(roundTo);
};

export const roundToDecimal = (value: number, roundTo: number = 2): number => {
  return Number(value?.toFixed(roundTo)) ?? 0;
};

export const GHGEmissionDataAsPerSubscription = (
  data: any[] | null | undefined,
  blockScope3: boolean
): any[] => {
  // Guard: invalid input → return as-is or empty
  if (!data || !Array.isArray(data)) {
    return data ?? [];
  }

  try {
    // Build lookup map for O(1) access
    const itemMap = new Map<string, any>();
    for (const item of data) {
      if (item?.dataId) {
        itemMap.set(item.dataId, item);
      }
    }

    const scopeTotalKey = GHGEmissionConst?.[0];
    const scope1Key = GHGEmissionConst?.[1];
    const scope2Key = GHGEmissionConst?.[2];
    const scope3Key = GHGEmissionConst?.[3];
    // Extract values safely
    const scope1 = checkNA(itemMap.get(scope1Key)?.value ?? 0);
    const scope2 = checkNA(itemMap.get(scope2Key)?.value ?? 0);
    const scope3 = checkNA(
      blockScope3 ? 0 : itemMap.get(scope3Key)?.value ?? 0
    );

    const totalItem = itemMap.get(scopeTotalKey);
    if (!totalItem) {
      return data; // No total → nothing to do
    }

    const newTotal = roundToDecimal(scope1 + scope2 + scope3);

    // Return updated array (immutable)
    return data.map((item: any) =>
      item.dataId === scopeTotalKey ? {...item, value: newTotal} : item
    );
  } catch (error) {
    // On ANY error → return original data
    console.warn(
      'reviseGHGEmissionData: Error, returning original data',
      error
    );

    return data;
  }
};
